import React, { useEffect, useRef, useState } from "react";
import {
  CButton, CCard, CCardBody, CCardHeader, CCol, CFormInput, CFormSelect, CModal,
  CRow, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow
} from "@coreui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFile } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-js-pagination";
import ViewDetails from "../loanDetails";
import { getAllCustomerDataNew } from "src/api/allApis";
import AddForm from "src/pages/customer/addForm";
import { useReactToPrint } from "react-to-print";
import { CSVLink } from "react-csv";
import { ModalBody, ModalHeader } from "react-bootstrap";
import AddCustomerGroup from "./updateCustomerGroup";
import { getAllGroup } from "src/redux/actions/userAction";
import ForImageUpload from "src/pages/customerData/forImageUpload";
import { COMPANY_AddLogo, COMPANY_Address, COMPANY_NAME } from "src/services/const";
import { formatDate } from "src/services/helpers";
import { useNavigate } from "react-router-dom";

const CustomerData = () => {
  const dispatch = useDispatch();
  const { AllGroups } = useSelector((state) => state?.userReducer);

  const [currentPage, setCurrentPage] = useState(1);
  const [showLoanSummary, setShowLoanSummary] = useState(false);
  const [showCustomerAddForm, setShowCustomerAddForm] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [customersPendingStatus, setCustomersPendingStatus] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [customerFilter, setCustomerFilter] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [printState, setPrintState] = useState(false);
  const SchemaName = sessionStorage.getItem("schemaName");
  const getEmployeeId = sessionStorage.getItem("emplyeeId");
  const employeeRole = sessionStorage.getItem("role");
  const branchId = sessionStorage.getItem("branc");
  const [filteredRows, setFilteredRows] = useState([]);
  const [visibleCustomerGroup, setVisibleCustomerGroup] = useState(false);
  const [activeCustomerid, setActiveCustomerid] = useState(0);
  const navigate = useNavigate();

  const getAllCompanyData = () => {
    const payload = { schemaName: SchemaName };
    getAllCustomerDataNew(payload).then((res) => {
      setCustomersPendingStatus(res?.data);
    });
  };

  useEffect(() => {
    getAllCompanyData();
  }, []);

  useEffect(() => {
    if (printState) generatePDF();
  }, [printState]);

  useEffect(() => {
    if (employeeRole == "agent") {
      const CustomerFilterData = customersPendingStatus?.filter(
        (m) => m?.employeeId === Number(getEmployeeId)
      );
      setCustomerFilter(CustomerFilterData);
    } else {
      setCustomerFilter(customersPendingStatus);
    }
  }, [customersPendingStatus]);

  const parseJsonField = (value) => {
    if (value && typeof value === "object") return value;
    if (typeof value !== "string" || !value.trim()) return {};

    try {
      return JSON.parse(value);
    } catch {
      return {};
    }
  };

  const filterRows = () => {
    if (Array.isArray(customerFilter)) {
      const filteredData = customerFilter.filter((customer) => {
        const GuarentorName = parseJsonField(customer?.nominee);
        const reference = parseJsonField(customer?.customerreference);
        const aadharNumber = customer?.aadharNumber?.toString()?.toLowerCase();
        const mobile = customer?.phoneNumber?.toString()?.toLowerCase();
        const fullName = customer?.firstName?.toLowerCase();
        const fatherName = customer?.fatherName?.toLowerCase();
        const grandFatherName = customer?.grandFatherName?.toLowerCase();
        const branchName = customer?.branch?.branchName?.toLowerCase();
        const branchCode = customer?.branch?.branchCode?.toLowerCase();
        const GuaranName = GuarentorName?.GuarantorName?.toLowerCase();
        const GuarantorMobileNumber =
          GuarentorName?.mobileNumber?.toLowerCase();
        const referenceName = reference?.refName?.toLowerCase();
        const referenceMobile = reference?.referencePhoneNumber?.toLowerCase();
        const loanAccountNum = customer?.loanAccountNumber.toLowerCase();
        const createdAt = formatDate(
          new Date(customer?.createdAt).toISOString().split("T")[0]
        );
        const searchTerm = searchInput?.toLowerCase();
        if (!searchTerm) return true;
        if (!isNaN(searchTerm))
          return (
            aadharNumber.includes(searchTerm) || mobile.includes(searchTerm)
          );
        if (/^\d{2}-\d{2}-\d{4}$/.test(searchTerm))
          return createdAt.includes(searchTerm);
        return [
          fullName,
          fatherName,
          grandFatherName,
          branchName,
          branchCode,
          GuaranName,
          GuarantorMobileNumber,
          referenceName,
          referenceMobile,
          loanAccountNum,
        ].some((value) => value?.includes(searchTerm));
      });
      setFilteredRows(filteredData);
    } else {
      setFilteredRows([]);
    }
  };

  useEffect(() => {
    filterRows();
    return () => {
      setFilteredRows([]);
    };
  }, [customerFilter, searchInput]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customerBranchData = filteredRows?.filter(
    (item) => branchId == item?.branchId
  );

  const dataSource =
    employeeRole === "employee" ? customerBranchData : filteredRows;

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = dataSource?.slice(indexOfFirstRow, indexOfLastRow);

  const handleViewForm = (customerdata) => {
    setCustomerData(customerdata);
    setShowLoanSummary(true);
  };

  const handleAddForm = (customerdata) => {
    setCustomerData(customerdata);
    setShowCustomerAddForm(true);
  };

  const [uploadDocument, setUploadDocument] = useState();
  const [showUploadModal, setShowUploadModal] = useState(false);
  const handleUploadDocument = (customerdata) => {
    setUploadDocument(customerdata?.id);
    setShowUploadModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };
  const componentPDF = useRef();
  const download_btn = () => {
    setPrintState(true);
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const objData = { schemaName: SchemaName };
    dispatch(getAllGroup(objData));
  }, [SchemaName, dispatch]);

  return (
    <>
      <CRow className="content">
        <CModal
          className="fullPageModal"
          backdrop="static"
          visible={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          aria-labelledby="StaticBackdropExampleLabel"
          size="xl"
        >
          <ModalHeader>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ flex: 1 }}>Upload your Document Here</div>
              <div
                style={{ flexShrink: 0, cursor: "pointer" }}
                onClick={() => setShowUploadModal(false)}
              >
                Close
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            <ForImageUpload
              uploadDocument={uploadDocument}
              setShowUploadModal={setShowUploadModal}
            />
          </ModalBody>
        </CModal>
        <CCol xs={12}>
          {showCustomerAddForm && (
            <>
              <CModal
                className="fullPageModal"
                backdrop="static"
                visible={showCustomerAddForm}
                onClose={() => setShowCustomerAddForm(false)}
                aria-labelledby="StaticBackdropExampleLabel"
                size="xl"
              >
                <AddForm
                  customerData={customerData}
                  showCustomerAddForm={showCustomerAddForm}
                  setShowCustomerAddForm={setShowCustomerAddForm}
                  getAllCompanyData={getAllCompanyData}
                />
              </CModal>
            </>
          )}
          {showLoanSummary ? (
            <ViewDetails
              customerData={customerData}
              setShowLoanSummary={setShowLoanSummary}
              showLoanSummary={showLoanSummary}
            />
          ) : (
            <>
              <CRow>
                <CCol xs={12}>
                  <CCard className="mb-4 custom-card">
                    <CCardHeader className="custom-card-header">
                      <h5>Customer Details</h5>
                    </CCardHeader>
                    <CCardBody>
                      <CRow>
                        <CCol xs={12}>
                          <CCard>
                            <div className="search_bar">
                              <div className="search-inner">
                                <div className="select-wrapper mr-10">
                                  <CFormSelect
                                    onChange={handleRowsPerPageChange}
                                    size="sm"
                                    className="mb-3 custom-form-input"
                                    style={{ cursor: "pointer" }}
                                    aria-label="Small select example"
                                  >
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                  </CFormSelect>
                                </div>

                                <div
                                  className="search-wrapper  mr-10"
                                  style={{ display: "flex" }}
                                >
                                  <CFormInput
                                    type="text"
                                    size="sm"
                                    placeholder="Enter desired value for searching"
                                    aria-label="sm input example"
                                    style={{ margin: "0px 0px 16px 0px" }}
                                    onChange={handleSearchChange}
                                    value={searchInput}
                                    className="custom-form-input"
                                  />
                                  <span className="search-icon">
                                    <i className="fa fa-search"></i>
                                  </span>
                                </div>
                              </div>
                              <div className="btn_add mt-0 mb-14">
                                <CButton
                                  className="add-btn mr-10 w-auto"
                                  onClick={download_btn}
                                >
                                  Download
                                </CButton>
                                <CSVLink
                                  data={
                                    currentRows === undefined
                                      ? " "
                                      : currentRows
                                  }
                                  filename={"customer-details.csv"}
                                >
                                  <CButton className="add-btn w-auto m-0">
                                    CSV
                                  </CButton>
                                </CSVLink>
                              </div>
                            </div>
                            <CCardBody>
                              <div className="new-table-container">
                                <div
                                  className="new-common-table-wrapper mb-2"
                                  ref={printState ? componentPDF : null}
                                  style={{
                                    padding: printState ? "20px" : "0px",
                                  }}
                                >
                                  {printState && (
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        background:
                                          "linear-gradient(180deg, #1e2639, #222b40, #4c5a7a, #7c90c2)",
                                        padding: "20px",
                                      }}
                                    >
                                      <img
                                        src={COMPANY_AddLogo}
                                        alt="Logo"
                                        width="50px"
                                        height="50px"
                                      />
                                      <p style={{ color: "#FFF" }}>
                                        Customer List
                                      </p>
                                      <div style={{ textAlign: "start" }}>
                                        <p
                                          style={{
                                            fontWeight: "bold",
                                            color: "#FFF",
                                            fontSize: "20px",
                                          }}
                                        >
                                          {COMPANY_NAME}
                                        </p>
                                        <p
                                          style={{ color: "#FFF" }}
                                        >{`(${COMPANY_Address})`}</p>
                                      </div>
                                    </div>
                                  )}
                                  <CTable
                                    className="custom-tablee"
                                    style={{ marginTop: "20px" }}
                                    hover
                                    responsive
                                  >
                                    <CTableHead>
                                      <CTableRow>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-1"
                                        >
                                          S. No.
                                        </CTableHeaderCell>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          Loan Date
                                        </CTableHeaderCell>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-1"
                                        >
                                          Loan ID
                                        </CTableHeaderCell>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          Member Name
                                        </CTableHeaderCell>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          Father Name
                                        </CTableHeaderCell>
                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          GrandFather Name
                                        </CTableHeaderCell>

                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          Branch Name
                                        </CTableHeaderCell>

                                        <CTableHeaderCell
                                          scope="col"
                                          className="col-md-2"
                                        >
                                          Mobile
                                        </CTableHeaderCell>

                                        {employeeRole !== "employee" &&
                                          !printState && (
                                            <CTableHeaderCell
                                              scope="col"
                                              className="col-md-1"
                                            >
                                              Action
                                            </CTableHeaderCell>
                                          )}
                                        {employeeRole !== "employee" &&
                                          !printState && (
                                            <CTableHeaderCell
                                              scope="col"
                                              className="col-md-2"
                                            >
                                              Edit
                                            </CTableHeaderCell>
                                          )}
                                        {!printState && (
                                          <>
                                            <CTableHeaderCell
                                              scope="col"
                                              className="col-md-2"
                                            >
                                              Documents Upload
                                            </CTableHeaderCell>
                                            <CTableHeaderCell
                                              scope="col"
                                              className="col-md-2"
                                            >
                                              Emi Record
                                            </CTableHeaderCell>
                                          </>
                                        )}
                                      </CTableRow>
                                    </CTableHead>
                                    <CTableBody>
                                      {Array.isArray(dataSource) &&
                                        currentRows?.map((company, index) => {
                                          return (
                                            <CTableRow key={index}>
                                              <CTableDataCell>
                                                {indexOfFirstRow + index + 1}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {formatDate(
                                                  (company?.createdAt).split(
                                                    "T"
                                                  )[0]
                                                )}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.loanAccountNumber}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.firstName}{" "}
                                                {company?.middleName ===
                                                  "undefined"
                                                  ? ""
                                                  : company?.middleName}{" "}
                                                {company?.lastName}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.fatherName
                                                  ? company?.fatherName
                                                  : "--"}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.grandFatherName
                                                  ? company?.grandFatherName
                                                  : "--"}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.branch?.branchName}
                                              </CTableDataCell>
                                              <CTableDataCell>
                                                {company?.phoneNumber}
                                              </CTableDataCell>

                                              {employeeRole !== "employee" &&
                                                !printState && (
                                                  <CTableDataCell className="col-md-1">
                                                    <button
                                                      style={{
                                                        gap: "2px",
                                                        border: "none",
                                                        backgroundColor:
                                                          "#007bff", // Blue button color
                                                        borderRadius: "7px", // Rounded corners
                                                        color: "white",
                                                        margin: "2px 8px", // Increased padding for larger button
                                                        fontSize: "14px", // Adjust font size for better readability
                                                        width: "80px", // Set width to ensure consistent button size
                                                        display: "flex",
                                                        justifyContent:
                                                          "center", // Center align content inside the button
                                                        alignItems: "center", // Center align content vertically
                                                      }}
                                                      className="view-button btn_view margin_auto"
                                                      onClick={() =>
                                                        handleViewForm(company)
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        role="button"
                                                        icon={faEye}
                                                        size="1x"
                                                        className="viewIcon "
                                                      />
                                                      Proceed
                                                    </button>
                                                  </CTableDataCell>
                                                )}
                                              {employeeRole !== "employee" &&
                                                !printState && (
                                                  <CTableDataCell className="col-md-2">
                                                    <button
                                                      style={{
                                                        gap: "2px",
                                                        border: "none",
                                                        backgroundColor:
                                                          "#007bff", // Blue button color
                                                        borderRadius: "7px", // Rounded corners
                                                        color: "white",
                                                        margin: "2px 8px", // Increased padding for larger button
                                                        fontSize: "14px", // Adjust font size for better readability
                                                        width: "80px", // Set width to ensure consistent button size
                                                        display: "flex",
                                                        justifyContent:
                                                          "center", // Center align content inside the button
                                                        alignItems: "center", // Center align content vertically
                                                      }}
                                                      className="view-button btn_view margin_auto"
                                                      onClick={() =>
                                                        handleAddForm(company)
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        role="button"
                                                        icon={faFile}
                                                        size="1x"
                                                        className="viewIcon "
                                                      />
                                                      Edit
                                                    </button>
                                                  </CTableDataCell>
                                                )}
                                              {!printState && (
                                                <>
                                                  <CTableDataCell className="col-md-2">
                                                    <button
                                                      style={{
                                                        gap: "2px",
                                                        border: "none",
                                                        backgroundColor:
                                                          "#007bff", // Blue button color
                                                        borderRadius: "7px", // Rounded corners
                                                        color: "white",
                                                        margin: "2px 8px", // Increased padding for larger button
                                                        fontSize: "14px", // Adjust font size for better readability
                                                        width: "80px", // Set width to ensure consistent button size
                                                        display: "flex",
                                                        justifyContent:
                                                          "center", // Center align content inside the button
                                                        alignItems: "center", // Center align content vertically
                                                      }}
                                                      className="view-button btn_view margin_auto"
                                                      onClick={() =>
                                                        handleUploadDocument(
                                                          company
                                                        )
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        role="button"
                                                        icon={faFile}
                                                        size="1x"
                                                        className="viewIcon "
                                                      />
                                                      Upload
                                                    </button>
                                                  </CTableDataCell>
                                                  <CTableDataCell className="col-md-2">
                                                    <button
                                                      style={{
                                                        gap: "2px",
                                                        border: "none",
                                                        backgroundColor:
                                                          "#007bff",
                                                        borderRadius: "7px",
                                                        color: "white",
                                                        margin: "2px 8px",
                                                        fontSize: "14px",
                                                        width: "80px",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        alignItems: "center",
                                                      }}
                                                      className="view-button btn_view margin_auto"
                                                      onClick={() =>
                                                        navigate(
                                                          `/emi-details?account_number=${company.loanAccountNumber}`
                                                        )
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        role="button"
                                                        icon={faFile}
                                                        size="1x"
                                                        className="viewIcon "
                                                      />
                                                      Emi Record
                                                    </button>
                                                  </CTableDataCell>
                                                </>
                                              )}
                                            </CTableRow>
                                          );
                                        })}
                                    </CTableBody>
                                  </CTable>
                                </div>

                                <div className="pagin-div">
                                  <div
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Showing {indexOfFirstRow + 1} to{" "}
                                    {Math?.min(
                                      indexOfLastRow,
                                      dataSource?.length
                                    )}{" "}
                                    of {dataSource?.length} entries
                                  </div>
                                  <div className="pagination-container">
                                    <ReactPaginate
                                      activePage={currentPage}
                                      itemsCountPerPage={rowsPerPage}
                                      totalItemsCount={dataSource?.length}
                                      pageRangeDisplayed={5}
                                      onChange={handlePageChange}
                                      prevPageText="Previous"
                                      nextPageText="Next"
                                      firstPageText="First"
                                      lastPageText="Last"
                                      innerClass="pagination"
                                      itemClass="page-item"
                                      linkClass="page-link"
                                    />
                                  </div>
                                </div>
                              </div>
                            </CCardBody>
                          </CCard>
                        </CCol>
                      </CRow>
                    </CCardBody>
                  </CCard>
                </CCol>
              </CRow>
            </>
          )}
        </CCol>
        <CCol xs={12}></CCol>
        {visibleCustomerGroup && (
          <AddCustomerGroup
            setVisibleCustomerGroup={setVisibleCustomerGroup}
            visibleCustomerGroup={visibleCustomerGroup}
            activeCustomerid={activeCustomerid}
            setActiveCustomerid={setActiveCustomerid}
            AllGroupsLoan={AllGroups?.data}
            getAllCompanyData={getAllCompanyData}
          />
        )}
      </CRow>
    </>
  );
};

export default CustomerData;
